export const information = [

    {
      id: 1,
      title: "Datos Generales",     
      content: [
        { label: "Nombre", value: `aaa` },
        { label: "Fecha de Nacimiento", value: `Aaaa` },
        { label: "Teléfono", value: `aaaa` },
        { label: "Rol", value: `aaaa` },
      ],
      imageSrc: "/img/user.png",
    },
  
    {
      id: 2,
      title: "Información Laboral",
      content: [
        { label: "Cargo", value: `aaa` },
        { label: "Empresa", value: "Megalabs" },
        { label: "Info", value: "N/A es un Visitador Médico Especializado con experiencia en el sector farmacéutico. Actualmente trabaja en Megalabs, donde se encarga de promover productos médicos, asistir a profesionales de la salud y proporcionar información detallada sobre los medicamentos y servicios de la compañía." },
        { label: "Experiencia", value: "10 Años" },
      ],
    },
    {
      id: 3,
      title: "Educación",
      content: [
        { label: "Licenciatura", value: "Medicina General" },
        { label: "Especialización", value: "Cardiología" },
        { label: "Universidad", value: "Universidad de la Salud" },
      ],
    },
    {
      id: 4,
      title: "Cursos completados",
      content: [
        { label: "Medicina General ", value: "Completado" },
        { label: "Emergencias Medicas", value: "Completado" },
        { label: "Enfermeria Avanzada", value: "Incompleto" },
        { label: "Medicina Interna", value: "Incompleto" },
        { label: "Cirugia General", value: "Incompleto" },
      ],
    },
    {
      id: 5,
      title: "Ajustes",
      content: [
        { label: "Personalice la configuración de su cuenta y vea cómo se usan sus datos"},
        { label: "Idioma", value: "Snanish(Spain)" },
        { label: "Zona horaria", value: "UTC-05:00 Bogotá" },
      ],
    },
  ];
  